import { IPromo } from '../../../../../types/newbuilding/promos';

export function getImageUrl(promo: IPromo): string {
  if (promo.isFromBank) {
    return promo.bank?.secondSquareImageUrl || '';
  }

  return promo.authorLogoUrl || '';
}
